/**
 * Design Tokens - Typography
 * Exported from Figma: Enersee Platform 2.0 - _Foundation_DesignSystem
 *
 * Typography tokens including font families, sizes, weights, and line heights.
 */

export const typographyTokens = {
  // Font Families
  fontFamily: {
    body: 'DM Sans',
    display: 'DM Sans',
  },

  // Font Sizes
  fontSize: {
    xs: '12px', // text-xs
    sm: '14px', // text-sm
    md: '16px', // text-md
    lg: '18px', // text-lg
    xl: '20px', // text-xl
    'display-xs': '24px', // display-xs
    'display-xl': '60px', // display-xl
  },

  // Font Weights
  fontWeight: {
    regular: '400',
    medium: '500',
    semibold: '600',
  },

  // Line Heights
  lineHeight: {
    xs: '18px', // text-xs
    sm: '20px', // text-sm
    md: '24px', // text-md
    lg: '28px', // text-lg
    xl: '30px', // text-xl
    'display-xs': '32px', // display-xs
    'display-xl': '72px', // display-xl
  },

  // Text Style Presets
  textStyles: {
    'text-xs-medium': {
      fontFamily: 'DM Sans',
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '18px',
    },
    'text-sm-medium': {
      fontFamily: 'DM Sans',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '20px',
    },
    'text-md-regular': {
      fontFamily: 'DM Sans',
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '24px',
    },
    'text-md-semibold': {
      fontFamily: 'DM Sans',
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '24px',
    },
    'text-lg-regular': {
      fontFamily: 'DM Sans',
      fontSize: '18px',
      fontWeight: '400',
      lineHeight: '28px',
    },
    'text-xl-regular': {
      fontFamily: 'DM Sans',
      fontSize: '20px',
      fontWeight: '400',
      lineHeight: '30px',
    },
    'text-xl-semibold': {
      fontFamily: 'DM Sans',
      fontSize: '20px',
      fontWeight: '600',
      lineHeight: '30px',
    },
    'display-xs-semibold': {
      fontFamily: 'DM Sans',
      fontSize: '24px',
      fontWeight: '600',
      lineHeight: '32px',
    },
    'display-xl-semibold': {
      fontFamily: 'DM Sans',
      fontSize: '60px',
      fontWeight: '600',
      lineHeight: '72px',
    },
  },
} as const;

export type TypographyTokens = typeof typographyTokens;
